import { List } from '@mui/material'
import {
  PolicyType,
  PrivacyType,
  privacyTypes,
  UserPolicy,
} from '@weblite/ts-action/user-policy'
import { SettingsSection } from '$common/settings-section'
import {
  SettingsItemWithText,
  SettingsItemWithIcon,
} from '$common/settings-item'
import { ArrowIOSIcon } from '$common/icons/arrow-ios'

import { useAsyncFunction } from '$func/async-function.react-hook'

import { t } from '$i18n'
import { getUserPolicy } from '$logic/user-policy'
import { openBlockedUsers, openPrivacyTypeSettings } from '$logic/router'

export function SettingsPrivacy() {
  const { value: policies } = useAsyncFunction<UserPolicy[]>(
    () => Promise.all(privacyTypes.map(getUserPolicy)),
    [],
  )

  const getPolicy = (index: number): PolicyType | undefined => {
    return policies?.[index]?.policy
  }
  const getException = (index: number) => {
    const policyData = policies?.[index]
    return {
      include: policyData?.include.length,
      exclude: policyData?.exclude.length,
    }
  }

  return (
    <SettingsSection headerText={t('settings.sections.privacy.title')}>
      <List disablePadding>
        <SettingsItemWithIcon
          text={t('settings.sections.privacy.blockedUsers')}
          Icon={ArrowIOSIcon}
          onClick={openBlockedUsers}
        />

        {privacyTypes.map((privacyType: PrivacyType, idx) => (
          <SettingsItemWithText
            key={privacyType}
            text={t(`settings.privacy.type.${privacyType.toLowerCase()}`)}
            secondaryText={
              getPolicy(idx) &&
              t(`settings.privacy.policy.${getPolicy(idx)?.toLowerCase()}`) +
                t('settings.privacy.policy.exceptions')(
                  getPolicy(idx) !== 'EVERY_BODY'
                    ? getException(idx).include
                    : 0,
                  getPolicy(idx) !== 'NO_BODY' ? getException(idx).exclude : 0,
                )
            }
            onClick={() => openPrivacyTypeSettings(privacyType)}
          />
        ))}
      </List>
    </SettingsSection>
  )
}
